// *https://www.registers.service.gov.uk/registers/country/use-the-api*
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { load_data, get_data } from "./data_api"
import throttle from 'lodash/throttle';

export default function ModelAutoComplete(props) {
    const [open, setOpen] = React.useState(false);
    const [querystr, setQuerystr] = useState("")
    const [value, setValue] = useState(props.value)
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = useState(false)
    const model_name = props.columnDef.foreign_model
    const name_field = props.columnDef.auto_complete_config.name_field
    const output_field = props.columnDef.auto_complete_config.output_field


    const fetch = React.useMemo(
        () =>
            throttle((request, callback) => {
                load_data(...request).then(callback);
            }, 2000),
        [],
    );

    React.useEffect(() => {
        let active = true;
        setLoading(true);
        fetch([model_name, { page: 0, pageSize: 5, search: querystr }],
            (candidates) => {
                setLoading(false)
                let _options = candidates.data.data.map((i) => ({ ...i }))
                if (active) {
                    setOptions(_options);
                }
            }
        )

        return () => {
            active = false;
        };
    }, [querystr, fetch]);


    React.useEffect(() => {
        if (props.value !== "" && props.value !== undefined) {
            get_data(model_name, props.value[output_field])
                .then((record) => {
                    setValue(record)
                })
        }
    }, [props.value]);


    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    return (
        <Autocomplete
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            value={value}
            getOptionSelected={(option, value) => (option[output_field] === value[output_field])}
            filterOptions={(options, params) => options}
            getOptionLabel={(option) => option[name_field]}
            options={options}

            onInputChange={(event, newInputValue) => {
                setQuerystr(newInputValue)
            }}
            onChange={(e, newValue) => {
                setValue(newValue)
                if (newValue === null) newValue = { value: null }
                props.onChange(newValue, newValue)
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.columnDef.title}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    {...props}
                    onChange={(e) => {
                        setQuerystr(e.target.value)
                    }}
                />
            )}
        />
    );
}
